import { jobApplyWithSonicApplyButtonClickedEvent } from '@lib/analytics-events/job'
import { useJobStore } from '@stores/job.store'
import { useCallback } from 'react'
import { useShallow } from 'zustand/react/shallow'

import { useSearchStore } from '@stores/search.store'
import { JobItem } from '@types'
import { match } from 'ts-pattern'

const SONICJOBS_PARTNER_CODE = 'sjw'

export default function useApplyWithSonicApply(): () => void {
  const [job] = useJobStore(useShallow((state) => [state.job]))
  const [search] = useSearchStore(useShallow((state) => [state.search, state.serpPositionClicked]))
  const locale = 'us'

  const baseUrl = match(process.env.NEXT_PUBLIC_ENVIRONMENT || 'local')
    .with('production', () => 'apply.sonicjobs.com')
    .with('local', () => 'easy-apply-micro.sonic-local.com')
    .with('feature', () => 'easy-apply-micro.main.sonic-dev.net')
    .with('staging', () => 'easy-apply-micro.main.sonic-dev.net')
    .otherwise(() => 'easy-apply-micro.main.sonic-dev.net')

  return useCallback(() => {
    jobApplyWithSonicApplyButtonClickedEvent(job as unknown as JobItem, search)
    if (job) {
      // Read at click time rather than mount time: this is a click handler, so the query string it
      // needs to carry is whatever is on the page right now, not whatever it was when the hook first
      // rendered. Removes the state + effect that used to mirror it. [S20-865]
      const sp = typeof window !== 'undefined' ? new URLSearchParams(window.location.search).toString() : ''
      const sonicApplyJobUrl = `https://${baseUrl}/${locale}/${SONICJOBS_PARTNER_CODE}/${job.id}?${sp}`
      window.open(sonicApplyJobUrl, '_blank')
    }
  }, [job, search, baseUrl, locale])
}
